import { Link, useLocation } from 'react-router-dom';
import { getLangFromPath, pathForLang } from '../lib/i18n.js';

export default function LangToggle() {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const otherLang = lang === 'en' ? 'fr' : 'en';
  const otherPath = pathForLang(location.pathname, otherLang);

  return (
    <Link
      to={otherPath}
      className="lang-toggle"
      aria-label={otherLang === 'fr' ? 'Passer au français' : 'Switch to English'}
      hrefLang={otherLang}
    >
      {otherLang.toUpperCase()}
    </Link>
  );
}
